import { useSelector } from 'react-redux';

import { useBreakpointValue, Box, Text } from '@frontend/components';

import {
  getBusinessName,
  getIsLoggedIn,
  getUserFullName,
} from 'store/session/selectors';

const Nameplate = ({ isMicroAppHeader, textAlign, display = 'unset' }) => {
  const isMobile = useBreakpointValue({
    base: true,
    tablet: true,
    desktop: false,
  });
  const isLoggedIn = useSelector(getIsLoggedIn);
  const userGroupName = useSelector(getBusinessName);
  const userFullName = useSelector(getUserFullName);

  if (!isLoggedIn) return null;

  return isMicroAppHeader && isMobile ? (
    <></>
  ) : isMicroAppHeader ? (
    <Box
      minWidth="fit-content"
      display="flex"
      verticalAlign="middle"
      textAlign={textAlign}
    >
      <Text
        size="sm"
        lineHeight="md"
        color="currentColor"
        textTransform="uppercase"
        mr={1}
        pt="3px"
      >
        {userGroupName}
      </Text>
      <Text fontWeight="bold" color="currentColor" pt="2px">
        {userFullName}
      </Text>
    </Box>
  ) : (
    <Box
      minWidth="fit-content"
      verticalAlign="middle"
      textAlign={textAlign}
      display={display}
    >
      <Text fontWeight="bold" color="currentColor">
        {userFullName}
      </Text>
      <Text size="sm" color="currentColor" textTransform="uppercase">
        {userGroupName}
      </Text>
    </Box>
  );
};

export default Nameplate;
